module.exports = __webpack_public_path__ + "static/media/segmedic-logo-white.105f22f7.svg";